import {authHeader, ApiConfigs} from "../_helpers";
import { authService } from "./auth.service";

export const kioskService = {
    getAll,
    show,
    create,
    update,
    delete: _delete,
    getAllWithPagination,
    filter,
    connectDevice,
    refreshDevice,
    logoutDevice

};
    
function getAll() {
    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials : 'include' as RequestCredentials, 
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosk.getAll}`, requestOptions)
        .then(
            handleResponse
        );
}

function getAllWithPagination(currentPage: number, perPage:any) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.getAll}?page=${currentPage}&per_page=${perPage}`, requestOptions)
        .then(
            handleResponse
        );
}

function filter(key:string,value:string, page:any, perPage:any) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json", "Accept": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.getAll}?keys=${key}&values=${value}&page=${page}&per_page=${perPage}`, requestOptions)
        .then(
            handleResponse
        );
}




function create(formData:FormData ){
    const requestOptions = {
        method: "POST",
        headers: { "Accept": "application/json" },
        credentials : 'include' as RequestCredentials,
        body: formData,
    };
    
    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.create}`, requestOptions)
        .then(
            handleResponse
        );
}

function show(id: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.show.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}

function update(id: string, payload: object) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'PUT',
        headers: { ...authHeader(), "Accept": "application/json", "Content-Type": "application/json" },
        body:  JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosk.update.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function _delete(id: string) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosk.delete.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function connectDevice(id:string, payload: object){
    const requestOptions = {
        method: "POST",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.connect}${id}/auth`, requestOptions)
        .then(
            handleResponse
        );
    
}

function logoutDevice(id:string){
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
       
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.logout.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );

    
    
}

function refreshDevice(id:string){
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
       
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.kiosk.refresh.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );

    
    
}


function handleResponse(response: any) {
    return response.text().then((text: string) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem('user');

                location.reload();
                authService.logout();
            }
            const error = (data && data.message) || response.status || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
